export const INITIAL_USER_LIST_COLUMNS = [
  {
    key: 'username',
    label: 'Username',
    isChecked: true,
    isPinned: true,
    isSortable: false,
    minWidth: '12.75',
  },
  {
    key: 'userSource',
    label: 'Identity Source',
    isChecked: true,
    isPinned: true,
    isSortable: false,
    minWidth: '11rem',
  },
  {
    key: 'employeeType',
    label: 'Employee Type',
    isChecked: true,
    isPinned: true,
    isSortable: false,
    minWidth: '11rem',
  },
  {
    key: 'email',
    label: 'Email',
    isChecked: true,
    isPinned: true,
    isSortable: false,
    minWidth: '12rem',
  },
  {
    key: 'manager',
    label: 'Manager',
    isChecked: true,
    isPinned: true,
    isSortable: false,
    minWidth: '10rem',
  },
  {
    key: 'statuskey',
    label: 'Status',
    isChecked: true,
    isPinned: true,
    isSortable: false,
    minWidth: '7rem',
  },
  {
    key: 'actionColumn',
    label: 'actionColumn',
    isChecked: true,
    isPinned: true,
    isColumnConfigEnabled: false,
    minWidth: 'min-content',
  },
];
